import { render, staticRenderFns } from "./MbHorizontalCalendar.vue?vue&type=template&id=71c3fa44&scoped=true&"
import script from "./MbHorizontalCalendar.vue?vue&type=script&lang=js&"
export * from "./MbHorizontalCalendar.vue?vue&type=script&lang=js&"
import style0 from "./MbHorizontalCalendar.vue?vue&type=style&index=0&id=71c3fa44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c3fa44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
